import { BaseEvent } from 'events/BaseEvent';

export class ReleaseDwarfEvent extends BaseEvent {}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/events/ReleaseDwarfEvent.ts